export function decorateCoupon(coupon, subtotal) {
  coupon.discountAmountDisplay =
    coupon.discount.discountType === "AMOUNT"
      ? coupon.discount.amount.toFixed(2)
      : (subtotal * coupon.discount.percentage / 100).toFixed(2);
  if (coupon.discount.discountType === "PERCENT") {
    coupon.discountPercentageDisplay = coupon.discount.percentage;
  }
  return coupon;
}